import { useEffect, useReducer, useState } from "react";
import { useLogging } from "../../../Shared/hooks/useLogging/useLogging";
import { getSubscriptions, updateSubscriptionDeliveryPickupLocation } from "../../utils/requests";
import { onFetchError, onFetchSuccess, subscriptionsReducer } from "../subscriptionsUtils/helperFunctions";
export const useSubscriptions = () => {
    const [pageNumber, setPageNumber] = useState(1);
    const [isErrorState, setIsErrorState] = useState(false);
    const [errorMessage, setErrorMessage] = useState("An error has occurred.");
    const [isLoading, setIsLoading] = useState(true);
    const { datadogLog } = useLogging();
    const [subscriptionsStore, dispatch] = useReducer(subscriptionsReducer, {
        subscriptions: {},
        cancelReasons: [],
        customerData: {},
        customText: {},
    });
    const onSuccess = onFetchSuccess(setIsErrorState, setIsLoading, setErrorMessage, dispatch);
    const onError = onFetchError(setIsErrorState, setIsLoading, setErrorMessage, datadogLog);
    const refetchSubscriptions = () => {
        setIsLoading(true);
        getSubscriptions(onSuccess, onError);
    };
    useEffect(() => {
        getSubscriptions(onSuccess, onError);
    }, []);
    return {
        subscriptionsStore,
        dispatch,
        pageNumber,
        setPageNumber,
        isLoading,
        isErrorState,
        errorMessage,
        refetchSubscriptions,
        updateFunction: updateSubscriptionDeliveryPickupLocation,
    };
};
